import {
  SEND_TRANSACTION_RECEIPT_FAILED,
  SEND_TRANSACTION_RECEIPT_LOADING,
  SEND_TRANSACTION_RECEIPT_RESET,
  SEND_TRANSACTION_RECEIPT_SUCCESS,
} from "../types";

const initialState = {
  loading: false,
  error: null,
  status: null,
  data: null,
};

export const SendTransactionReceiptReducer = (
  state = initialState,
  action: {
    type: any;
    loading?: boolean;
    payload?: any;
    status?: any;
    error?: any;
  }
) => {
  switch (action.type) {
    case SEND_TRANSACTION_RECEIPT_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case SEND_TRANSACTION_RECEIPT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        status: action.status,
        error: null,
      };

    case SEND_TRANSACTION_RECEIPT_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
        data: null,
        status: null,
      };

    case SEND_TRANSACTION_RECEIPT_RESET:
      return initialState;

    default:
      return state;
  }
};

